import loggingApi from '@sleepstation/logger'
import { redirect } from '@sleepstation/utils'
import getEnvironment from '../config/getEnvironment'
import LOG_GROUP from '../const/logGroup'

// -----------------------------------------------------------------------------
// Const
// -----------------------------------------------------------------------------

const logger = loggingApi.getLogger({
  group: LOG_GROUP.AUTH,
})

const { HOST } = getEnvironment()

// -----------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------

export const getAppLoginURLWithRedirect = () => {
  const currentUrl = encodeURIComponent(window.location.href)
  return `${HOST.APP}/sessions/new?token=true&redirect_to=${currentUrl}`
}

export const redirectToLoginURL = () => {
  const url = getAppLoginURLWithRedirect()
  logger.info(`Redirecting to app login page`, url)
  redirect(url)
}
